import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../axiosInstance";
import { apiEndPoints } from "../../api/apiEndpoints";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

export const fetchDashboardData = createAsyncThunk(
  "fetchDashboardData",
  (queryString, { rejectWithValue }) => {
    return Axios.get(
      `${apiEndPoints.dashboard}${queryString || ""}`
    ).then((res) => res.data);
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard slice",
  initialState,
  reducers: {
    clearUtilsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // FETCH  UTILS API
    builder.addCase(fetchDashboardData.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(fetchDashboardData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchDashboardData.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });
  },
});

// SELECTORS
export const selectDashboardWhole = (store) => store?.dashboard;
export const selectDashoardLoader = (store) => store?.dashboard?.isLoading;

// ACTIONS TO DISPATCH
export const { clearUtilsError } = dashboardSlice.actions;

export default dashboardSlice.reducer;
